export default __webpack_public_path__ + "static/media/button-previous.6fc690ee.svg";